import React from 'react';

const ProfileDropdown = () => {
  const profileActions = [
    { title: 'My Profile', icon: 'bi-person', link: '/users-profile.html' },
    { title: 'Account Settings', icon: 'bi-gear', link: '/users-profile.html' },
    { title: 'Need Help?', icon: 'bi-question-circle', link: '/pages-faq.html' },
    { title: 'Sign Out', icon: 'bi-box-arrow-right', link: '#' },
  ];

  return (
    <li className="nav-item dropdown pe-3">
      <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
        <i className="bi bi-eye"></i>   
        <span className="d-none d-md-block dropdown-toggle ps-2">User Settings</span>
        <i className="bi bi-person"></i>

      </a>
      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
        <li className="dropdown-header">
          <span>Username</span>
          <i className="bi bi-person"></i>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        {profileActions.map((action, index) => (
          <React.Fragment key={index}>
            <li>
              <a className="dropdown-item d-flex align-items-center" href={action.link}>
                <i className={`bi ${action.icon}`}></i>
                <span>{action.title}</span>
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
          </React.Fragment>
        ))}
      </ul>
    </li>
  );
};

export default ProfileDropdown;
